import request from '@/utils/http.js';
import { roomApiList } from '@/request/env';
import { getQueryString } from '@/utils/index.js';


// 通过活动id获取活动拥有者用户id
function webinarInitBefore(params) {
  const url = roomApiList['webinarInitBefore']['v3'];
  return request({
    url,
    method: 'POST',
    data: params,
    headers: {
      'gray-Id': getQueryString("grayId"),
      token: ''
    }
  });
}

/**
 * 查看公众号引流配置
 * http://yapi.vhall.domain/project/1268/interface/api/58751
 * @param params
 * @returns {*}
 */
function wechatOaConfig(params = {}) {
  return request({
    url: '/v1/marketing/app/wechat-oa/get-diverting-config',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * (Web端)公众号-查询引流关注公众号二维码
 * http://yapi.vhall.com/project/1268/interface/api/58821
 * @param params
 * @returns {*}
 */
function wechatOaGetDivertingCode(params = {}) {
  return request({
    url: '/v1/marketing/app/wechat-oa/get-diverting-code',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * (Web端)公众号-查询某人是否已经关注公众号
 * http://yapi.vhall.com/project/1268/interface/api/58807
 * @param params
 * @returns {*}
 */
function wechatOaHasSubscribed(params = {}) {
  return request({
    url: '/v1/marketing/app/wechat-oa/has-subscribed',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 发起端获取主持人头像和昵称(角色登录使用)
 * https://yapi.vhall.com/project/99/interface/api/62150
 * @param params
 * @returns {*}
 */
function getRoleBasicInfo(params) {
  return request({
    url: '/v3/webinars/privilege/get-role-basic-info',
    method: 'POST',
    data: params,
    headers: {
      'gray-Id': getQueryString("grayId")
    }
  });
}

/**
 * 活动基本信息接口-简化版
 * @param {number} webinar_id
 * @param {object} params
 * @returns
 * 第一版只返回两个字段
  id:   活动id
  webinar_state：    活动状态
 */
function getWebinarBasicInfo(webinar_id, params) {
  return request({
    url: '/v3/webinars/webinar/basic-info',
    method: 'POST',
    data: {
      webinar_id,
      ...params
    }
  });
}


/**
 * 获取活动及主持人信息
 * @param {number|string} webinar_id
 * @returns
 */
function getWebinarAndHostInfo(webinar_id) {
  return request({
    url: '/v3/webinars/watch/get-webinar-and-host-info',
    method: 'GET',
    params: { webinar_id },
  });
}


export default {
  webinarInitBefore,
  wechatOaConfig,
  wechatOaGetDivertingCode,
  wechatOaHasSubscribed,
  getRoleBasicInfo,
  getWebinarBasicInfo,
  getWebinarAndHostInfo
};